import React from "react";
import { Bar } from "react-chartjs-2";
import { appStyles } from "../../../app/app-style";
import moment from "moment";
import { useSelector } from "react-redux";
import { config } from "../../../../enviroment";
import { useTranslation } from "react-i18next";
import { useTheme } from '@material-ui/core/styles';
const PFMDGraph = ({
  pfvalues,
  maxDemand,
  width,
  height,
  noData,
  isMobile,
  units,
  values
}) => {
  const {t:Labels, ready: labelReady} = useTranslation("label-HIGHEST_USAGE");
  const theme = useTheme();
  let MONTHLY_CHART_DATE_FORMAT = useSelector(
    (state) =>
      state?.parametersWidgets?.ParameterLookup
        ?.MONTHLY_VIEW_INTERVAL_SHORTNAME_DATE_FORMAT
  );
  MONTHLY_CHART_DATE_FORMAT = MONTHLY_CHART_DATE_FORMAT
    ? MONTHLY_CHART_DATE_FORMAT
    : config?.EnergyConsumption?.FALLBACK_MONTHLY_CHART_DATE_FORMAT;


  let data = {
    backgroundColor: "rgba(53, 162, 235, 0.5)",
    labels: values.map((e) => {
      return e.msrmtDateTime;
    }),
    datasets: [
      {
        yAxisID: "Power_Factor",
        label:labelReady?Labels("E_POW_FACTOR"): "Power Factor",
        data: values.map((e) => e.powerFactor),
        backgroundColor: theme.palette.eTertiary?.base,
        barPercentage: 0.3,
        borderRadius: {
          topLeft: 100,
          topRight: 100,
        },
      },
      { 
        yAxisID: "Maximum_Demand",
        label:labelReady?Labels("E_MAXI_DEMAND"): "Power Factor",
        data: values.map((e) => {return  e.maxDemand}),
        backgroundColor: theme.palette.eSecondary?.base,
        barPercentage: 0.3,
        borderRadius: {
          topLeft: 100,
          topRight: 100,
        },
      },
    ],
    order: 1,
  };
  return (
    <Bar
      height={height}
      data={data}
      width={width}
      options={{
        plugins: {
          tooltip: {
            enabled: true,
            usePointStyle: true,
            responsive: true,
            position: "average",
            mode: "nearest",
            intersect: false,
            backgroundColor: appStyles?.outerTheme?.palette?.whiteColor?.main,
            bodyColor: appStyles?.outerTheme?.palette?.eSecondaryColors?.fifth,
            bodyFontColor:
              appStyles?.outerTheme?.palette?.eSecondaryColors?.fifth,
            borderColor: appStyles?.outerTheme?.palette?.eLight?.base,
            padding: 10,
            borderWidth: 1,
            cornerRadius: 2,
            boxWidth: 6,
            boxHeight: 6,
            displayColors: true,
            callbacks: {
              title: () => null,
              label: function(context) {
                var label = "";
                if(context.dataset.label === Labels("E_POW_FACTOR")){
                  label = context.parsed.y.toFixed(2);
                  return label;
                }else{
                  label = context.parsed.y.toFixed(2);
                  return label+" "+Labels("E_MAXI_DEMAND_UNIT");
                }
              },
            },
          },
          legend: {
            display: values?.length>0,
            labels: {
              usePointStyle: true,
              textAlign: "left",
              boxWidth: 5,
              padding: isMobile ? 8 : 5,
              font: {
                size: isMobile ? 11 : 12,
              },
              color: appStyles?.outerTheme?.palette?.ePrimary?.base,
            },
            position: "bottom",
          },
        },
        maintainAspectRatio: false,
        scales: {
            Power_Factor: {
            position:"left",
            grid: {
              display: true,
              drawBorder: false,
            },
            ticks: {
              beginAtZero: true,
              max: 0.6,
              color: theme.palette.eTertiary?.base,
              callback: function(value, index, values) {
                return value+" "+Labels("E_POW_FACTOR_UNIT");
              },
            },
            scaleLabel: {
              display: true,
            },
          },

          Maximum_Demand: {
            position:"right",
            grid: {
              display: true,
              drawBorder: false,
            },
            ticks: {
              beginAtZero: true,
              max: 0.6,
              color: theme.palette.eSecondary?.base,
              callback: function(value, index, values) {
                return value+" "+Labels("E_MAXI_DEMAND_UNIT");
              },
            },
            scaleLabel: {
              display: true,
            },
          },

          x: {
            grid: {
              drawTicks: true,
              drawBorder: true,
              display: false,
            },
            ticks: {
              color: appStyles?.outerTheme?.palette?.ePrimary?.base,
              padding: 5,
            },
          },
        },
        layout: {
          padding: 20,
        },
      }}
    />
  );
};

export default PFMDGraph;
